import {
  Loading as BaseLoading,
  Body,
  Input,
  Row,
  styled,
} from '@teko/ds-desktop';
import { CheckOutlined, SearchOutlined } from '@teko/ds-icon';
import { Area } from '@teko/location';
import { t } from 'i18n';
import { useRef } from 'react';

interface IPickAddressProps {
  placeHolderSearch: string;
  keyword: string;
  setKeyword: (keyword: string) => void;
  filterLocations: Area[];
  loadingLocation: boolean;
  onSelectLocation: (location: Area) => void;
  selectedValue: string;
}

export const PickAddress = ({
  placeHolderSearch,
  keyword,
  setKeyword,
  filterLocations,
  loadingLocation,
  onSelectLocation,
  selectedValue,
}: IPickAddressProps) => {
  const listRef = useRef<HTMLDivElement>();

  return (
    <>
      <StyledInput
        prefix={<SearchOutlined />}
        placeholder={placeHolderSearch}
        value={keyword}
        onChange={setKeyword}
      />
      <List
        ref={(ref) => {
          if (!ref) {
            return;
          }
          // remove right padding when scrollbar is visible
          if (ref.scrollHeight > ref.clientHeight) {
            ref.style.paddingRight = '0';
          }

          listRef.current = ref;
        }}
      >
        {filterLocations &&
        Array.isArray(filterLocations) &&
        filterLocations.length ? (
          filterLocations.map((location) => {
            const isSelected = location.code === selectedValue;
            return (
              <ListItem
                key={location.id}
                onClick={() => {
                  onSelectLocation(location);
                  setKeyword('');
                }}
                active={isSelected}
              >
                {location.title}
                {isSelected && (
                  <CheckOutlined color="primary500" size="1.5rem" />
                )}
              </ListItem>
            );
          })
        ) : (
          <Row justify="center" align="middle">
            {loadingLocation ? (
              <BaseLoading isLoading={loadingLocation} />
            ) : (
              <Body color="placeholder" level={1} weight="regular">
                {t('Không tìm thấy dữ liệu nào !!')}
              </Body>
            )}
          </Row>
        )}
      </List>
    </>
  );
};

const StyledInput = styled(Input)`
  width: 100%;
  margin-bottom: 15px;
  border-radius: 4px;
`;

const List = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: min(100vh, 28rem);
  padding-bottom: 0.75rem;
  ::-webkit-scrollbar {
    width: 0.75rem;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.disable};
    background-clip: content-box;
    border-radius: 100px;
    border: 0.25rem solid transparent;
    width: 0.25rem;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.placeholder};
  }
`;

const ListItem = styled.div<{ active?: boolean }>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
  display: flex;
  flex-direction: row;
  height: 3rem;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 15px;
  background-color: ${({ theme, active }) =>
    active ? theme.colors.background : theme.colors.white};
`;
